import angular from 'angular';

import Component from './event-schedule-viewer.component';

const Module = angular
    .module('control-room.commons.form.components.event-schedule-viewer', [])
    .component('crEventScheduleViewer', Component);

export default Module;
